export default "__VITE_ASSET__BRC8qfzS__"